























































import Vue, { PropType } from 'vue';
import {
  Item,
  Brand,
} from 'mostra';

export default Vue.extend({
  name: 'exhibitor-item-edit',
  props: {
    isNew: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    isCopy: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    copyId: {
      type: String as PropType<string | null>,
      default: null,
    },
    owner: {
      type: String as PropType<string>,
      required: true,
    },
    brands: {
      type: Array as PropType<Brand[]>,
      required: true,
    },
    item: {
      type: Object as PropType<Item>,
      required: true,
    },
    currentPage: {
      type: String as PropType<string>,
      required: true,
    },
    targetPageName: {
      type: String as PropType<string>,
      required: true,
    },
  },
  computed: {
    footerButtonText(): string {
      if (this.targetPageName === 'story') {
        return '保存';
      }
      return '保存して次へ';
    },
    headingTexts(): any[] {
      if (this.isNew) {
        return [{ text: '商品ページ新規作成' }];
      } else if (this.isCopy) {
        return [{ text: '商品ページ複製' }];
      } else {
        return [{ text: '商品ページ編集' }];
      }
    },
    buttons(): any[] {
      return [
        {
          theme: 'primary',
          text: '保存',
          onClick: this.onClickSave,
          withValidation: true,
        },
      ];
    },
    tabLinks(): any[] {
      const q = this.$route.query;
      let ls: any[] = [];
      if (!this.isNew && !this.isCopy) {
        ls.push({
          value: 4,
          text: 'プレビュー',
          to: {
            name: this.targetPageName,
            query: {
              ...q,
              page: 'preview',
            },
          },
          validationId: 'g-item-story-form',
        });
      }
      ls = ls.concat([
        {
          value: 0,
          text: '基本設定',
          to: {
            name: this.targetPageName,
            query: {
              ...q,
              page: 'settings',
            },
          },
          validationId: 'g-item-setting-form',
        },
        {
          value: 1,
          text: '画像登録',
          to: {
            name: this.targetPageName,
            query: {
              ...q,
              page: 'images',
            },
          },
          validationId: 'g-item-image-form',
        },
        {
          value: 2,
          text: 'SKU',
          to: {
            name: this.targetPageName,
            query: {
              ...q,
              page: 'sku',
            },
          },
          validationId: 'g-item-sku-form',
        },
        {
          value: 3,
          text: 'ストーリー',
          to: {
            name: this.targetPageName,
            query: {
              ...q,
              page: 'story',
            },
          },
          validationId: 'g-item-story-form',
        },
      ]);

      // for (const l of ls) {
      //   if (this.item.id) l.to.query.id = this.item.id;
      //   if (this.$router.) l.to.query.owner = this.owner;
      //   if (this.isCopy && this.copyId) l.to.query.copy = this.copyId;
      // }
      return ls;
    },
  },
  methods: {
    async onClickSave() {
      this.$emit('onClickSave');
    },
  },
});
